import MojitoCore from 'mojito/core';
import MojitoModules from 'mojito/modules';
import MojitoPresentation from 'mojito/presentation';
import MojitoServices from 'mojito/services';
import SearchUtils from 'applications/sports/components/search/utils.js';

const {
    actions: marketCatHintActions,
    types: { MARKET_CATEGORIES, STORABLE_PARAMS },
} = MojitoModules.EventMarkets;
const { Button, DateTime, FlexPane, SportIcon, Text } = MojitoPresentation.Components;
const { Types: IntentTypes } = MojitoPresentation.Base.Intent;
const { dispatch } = MojitoCore.Services.redux.store;
const intentActions = MojitoCore.Intents.actions;
const { EventFormatter } = MojitoPresentation.Utils;
const { RESULT_TYPE } = MojitoServices.Search.types;
const log = MojitoCore.logger.get('SearchResultRow');

const SearchResultRow = props => {
    const {
        item,
        isPlayerGroup,
        onNavigate,
        mojitoTools: { appContext, config, stringResolver },
    } = props;
    const { raceMeetingId, resultType, sportId, startTime } = item;

    const navigationData = SearchUtils.getResultNavigationData(item);
    if (!navigationData) {
        log.error(`Unexpected resultType ${resultType} in SearchResultRow`);
        return null;
    }

    const resolvedRoute = appContext.routeResolver.getRoute(navigationData);
    const hrefLink = isPlayerGroup
        ? SearchUtils.appendQueryParam(
              resolvedRoute,
              STORABLE_PARAMS.MARKET_CAT,
              MARKET_CATEGORIES.PLAYER_PROP
          )
        : resolvedRoute;
    const sportName = appContext.sportName(sportId);

    const onClick = () => {
        if (isPlayerGroup) {
            dispatch(marketCatHintActions.setMarketCatHint(MARKET_CATEGORIES.PLAYER_PROP));
        }
        dispatch(intentActions.publishIntent(IntentTypes.VIEW, navigationData));
        onNavigate();
        appContext.analyticsEmitter.emitAnalytics('searchResultsItemClicked', {
            sportId,
            name: item.name,
            parentName: item.parentName,
            resultType,
        });
    };

    return (
        <Button
            config={config.button}
            class="ta-searchResultRow"
            hrefLink={hrefLink}
            onClick={onClick}
        >
            <SportIcon sportId={sportId} config={config.sportIcon} alt={sportName} />
            <FlexPane config={config.namesContainer}>
                {resultType !== RESULT_TYPE.SPORT && item.parentName && (
                    <Text config={config.parentName}>{getParentName(item, stringResolver)}</Text>
                )}
                <Text config={config.name}>{getName(item, stringResolver)}</Text>
            </FlexPane>
            {resultType === RESULT_TYPE.EVENT && item.inPlay ? (
                <Text config={config.live}>
                    {stringResolver.resolveString('$SEARCH_DISCOVERY_VIEW.IN_PLAY_STATUS')}
                </Text>
            ) : (
                startTime && (
                    <Text config={config.startTime}>
                        <DateTime config={config.startTimeFormat} dateTime={startTime} />
                    </Text>
                )
            )}
        </Button>
    );

    function getParentName(item, resolver) {
        if (item.resultType === RESULT_TYPE.EVENT && !item.raceMeetingId) {
            return formatNameWithClass(item.parentName, item.sportClassName, resolver);
        }
        return item.parentName;
    }

    function getName(item, resolver) {
        if (item.resultType === RESULT_TYPE.SPORT) {
            return resolver.resolveAndFormatString(
                '$SEARCH_DISCOVERY_VIEW.ALL_SPORT_NAME',
                item.name
            );
        }
        if (item.resultType === RESULT_TYPE.TYPE) {
            return formatNameWithClass(item.name, item.sportClassName, resolver);
        }
        if (item.resultType === RESULT_TYPE.RACE_MEETING || raceMeetingId) {
            return EventFormatter.formatEventName(item.name);
        }
        return item.name;
    }
};

const formatNameWithClass = (name, sportClassName, stringResolver) => {
    if (!sportClassName) {
        return name;
    }
    return stringResolver.resolveAndFormatString(
        '$SEARCH_DISCOVERY_VIEW.TYPE_NAME_WITH_CLASS_NAME',
        name,
        sportClassName
    );
};

export default SearchResultRow;
